import request from '@/utils/request'

let ProgressApi = {
  /*获取表列表*/
  getProgress(data) {
    return request._get('/shop/progress.progress/getProgress', data);
  },

}
export default ProgressApi;



// WEBPACK FOOTER //
// ./src/api/progress.js